import { ESCALATION_RULE_ADD_DATA, DROPDOWN_CACHE, RULE_LIST, STATUS_DROPDOWN, CATEGORY_DROPDOWN, NOTIFICATION_VARIABLES, ESCALATION_GET_DATA, ESCALATION_RULE_UPDATE, ESCALATION_EXECUTIONS_GET } from "./Constants";

export const loadEscalationRuleAddRequest = (request) => ({
  type: ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_LOAD,
  request,
});

export const setEscalationRuleAddSuccess = (rule) => ({
  type: ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_SUCCESS,
  rule,
});

export const setEscalationRuleAddFail = (error) => ({
  type: ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_FAIL,
  error,
});

export const resetEscalationRuleAdd = () => ({
  type: ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_RESET,
});




export const loadDropdownCacheRequest = (endpoint) => ({
  type: DROPDOWN_CACHE.DROPDOWN_CACHE_LOAD,
  endpoint
});

export const setDropdownCacheSuccess = (endpoint, data) => ({
  type: DROPDOWN_CACHE.DROPDOWN_CACHE_SUCCESS,
  endpoint,
  data,
});

export const setDropdownCacheFail = (endpoint, error) => ({
  type: DROPDOWN_CACHE.DROPDOWN_CACHE_FAIL,
  endpoint,
  error,
});


export const ruleListRequest = () => ({
  type: RULE_LIST.RULE_LIST_LOAD,
});

export const setRuleListSuccess = (data) => ({
  type: RULE_LIST.RULE_LIST_SUCCESS,
  data,
});

export const setRuleListFail = (error) => ({
  type: RULE_LIST.RULE_LIST_FAIL,
  error,
});



// Category
export const loadCategoryDropdownRequest = (options={}) => ({
  type: CATEGORY_DROPDOWN.LOAD,
  payload: options,
});

export const setCategoryDropdownSuccess = (data) => ({
  type: CATEGORY_DROPDOWN.SUCCESS,
  data,
});

export const setCategoryDropdownFail = (error) => ({
  type: CATEGORY_DROPDOWN.FAIL,
  error,
});


// Ticket Statuses
export const loadStatusDropdownRequest = () => ({
  type: STATUS_DROPDOWN.LOAD,
});

export const setStatusDropdownSuccess = (data) => ({
  type: STATUS_DROPDOWN.SUCCESS,
  data,
});

export const setStatusDropdownFail = (error) => ({
  type: STATUS_DROPDOWN.FAIL,
  error,
});

// Notification Variables
export const loadNotificationVariablesRequest = () => ({
  type: NOTIFICATION_VARIABLES.LOAD,
});

export const setNotificationVariablesSuccess = (data) => ({
  type: NOTIFICATION_VARIABLES.SUCCESS,
  data,
});

export const setNotificationVariablesFail = (error) => ({
  type: NOTIFICATION_VARIABLES.FAIL,
  error,
});

export const ruleListDelete = (request) => ({
  type: RULE_LIST.RULE_LIST_DELETE,
  request,
});

export const setRuleListDeleteSuccess = (data) => ({
  type: RULE_LIST.RULE_LIST_DELETE_SUCCESS,
  data,
});

export const setRuleListDeleteFail = (error) => ({
  type: RULE_LIST.RULE_LIST_DELETE_FAIL,
  error,
});

// Trigger API fetch (called from component)
export const loadEscalationGetDataRequest = (id) => ({
  type: ESCALATION_GET_DATA.ESCALATION_GET_DATA_LOAD,
  id,
});

// On success
export const setEscalationGetDataSuccess = (data) => ({
  type: ESCALATION_GET_DATA.ESCALATION_GET_DATA_SUCCESS,
  data,
});

// On failure
export const setEscalationGetDataFail = (error) => ({
  type: ESCALATION_GET_DATA.ESCALATION_GET_DATA_FAIL,
  error,
});

// --- UPDATE (PUT)  For Escalation Rule ---
export const loadEscalationRuleUpdateRequest = (id, request) => ({
  type: ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_LOAD,
  id,
  request,
});

export const setEscalationRuleUpdateSuccess = (data) => ({
  type: ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_SUCCESS,
  data,
});

export const setEscalationRuleUpdateFail = (error) => ({
  type: ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_FAIL,
  error,
});

export const resetEscalationRuleUpdate = () => ({
  type: ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_RESET,
});


// Escalation Rule Executions

export const loadEscalationExecutionListRequest = (payload) => ({
  type: ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_LOAD,
  payload,
});

export const setEscalationExecutionListSuccess = (data) => ({
  type: ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_SUCCESS,
  data,
});

export const setEscalationExecutionListFail = (error) => ({
  type: ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_FAIL,
  error,
});

export const loadEscalationExecutionListRowCountRequest = (payload) => ({
  type: ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT,
  payload,
});

export const setEscalationExecutionListRowCountSuccess = (data) => ({
  type: ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT_SUCCESS,
  data,
});

export const setEscalationExecutionListRowCountFail = (error) => ({
  type: ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT_FAIL,
  error,
});



